const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatefulset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.035334mm",
    height: "17.500378mm",
    viewBox: "0 0 18.035334 17.500378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.99262638,-1.174181)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0148887,0,0,1.0148887,16.937424,-2.698726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -6.8492015,4.2724668 a 1.1191255,1.1099671 0 0 0 -0.4288818,0.1085303 l -5.8524037,2.7963394 a 1.1191255,1.1099671 0 0 0 -0.605524,0.7529759 l -1.443828,6.2812846 a 1.1191255,1.1099671 0 0 0 0.151943,0.851028 1.1191255,1.1099671 0 0 0 0.06362,0.08832 l 4.0508,5.036555 a 1.1191255,1.1099671 0 0 0 0.874979,0.417654 l 6.4961011,-0.0015 a 1.1191255,1.1099671 0 0 0 0.8749788,-0.416906 L 1.3818872,15.149453 A 1.1191255,1.1099671 0 0 0 1.5981986,14.210104 L 0.15212657,7.9288154 A 1.1191255,1.1099671 0 0 0 -0.45339794,7.1758396 L -6.3065496,4.3809971 A 1.1191255,1.1099671 0 0 0 -6.8492015,4.2724668 Z",
    style: {
      fill: "#326ce5",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -6.8523435,3.8176372 A 1.1814304,1.171762 0 0 0 -7.3044284,3.932904 l -6.1787426,2.9512758 a 1.1814304,1.171762 0 0 0 -0.639206,0.794891 l -1.523915,6.6308282 a 1.1814304,1.171762 0 0 0 0.160175,0.89893 1.1814304,1.171762 0 0 0 0.06736,0.09281 l 4.276094,5.317236 a 1.1814304,1.171762 0 0 0 0.92363,0.440858 l 6.8576188,-0.0015 a 1.1814304,1.171762 0 0 0 0.9236308,-0.44011 l 4.2745966,-5.317985 a 1.1814304,1.171762 0 0 0 0.228288,-0.990993 L 0.53894439,7.6775738 A 1.1814304,1.171762 0 0 0 -0.10026101,6.8834313 L -6.2790037,3.9321555 A 1.1814304,1.171762 0 0 0 -6.8523435,3.8176372 Z m 0.00299,0.4550789 a 1.1191255,1.1099671 0 0 1 0.5426517,0.1085303 l 5.85315169,2.7948425 A 1.1191255,1.1099671 0 0 1 0.15197811,7.9290648 L 1.598051,14.21035 a 1.1191255,1.1099671 0 0 1 -0.2163123,0.939348 l -4.0493032,5.037304 a 1.1191255,1.1099671 0 0 1 -0.8749789,0.416906 l -6.4961006,0.0015 a 1.1191255,1.1099671 0 0 1 -0.874979,-0.417652 l -4.0508,-5.036554 a 1.1191255,1.1099671 0 0 1 -0.06362,-0.08832 1.1191255,1.1099671 0 0 1 -0.151942,-0.851028 l 1.443827,-6.2812853 a 1.1191255,1.1099671 0 0 1 0.605524,-0.7529758 l 5.8524036,-2.7963395 a 1.1191255,1.1099671 0 0 1 0.4288819,-0.1085303 z",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "Sans",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      direction: "ltr",
      writingMode: "lr-tb",
      baselineShift: "baseline",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.26877762,1.0923105)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 0.52914584,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "1.58743761, 1.58743761",
      strokeDashoffset: 3.66698074,
      strokeOpacity: 1
    },
    d: "m 8.0530333,5.1290756 6.5250067,0 0,4.583335 -6.5250067,0 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 6.5142849,6.5403876 6.5250071,0 0,4.5833354 -6.5250071,0 z",
    style: {
      fill: "#326ce5",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 0.52914584,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "1.58743761, 1.58743761",
      strokeDashoffset: 3.87863898,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4.9755578,7.9516984 6.5249912,0 0,4.5833346 -6.5249912,0 z",
    style: {
      fill: "#ffffff",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.26458332,
      strokeLinecap: "square",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4.9755578,7.9516984 6.5249912,0 0,4.5833346 -6.5249912,0 z",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#ffffff",
      strokeWidth: 0.5291667,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5.5087198,9.2260482 0,0 c 0,-0.4294054 1.2218881,-0.7775054 2.7291615,-0.7775054 1.5072743,0 2.7291787,0.3481 2.7291787,0.7775054 l 0,0 c 0,0.4294054 -1.2219044,0.7775068 -2.7291787,0.7775068 -1.5072734,0 -2.7291615,-0.3481014 -2.7291615,-0.7775068 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.26458332,
      strokeLinecap: "square",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.967067,9.2260482 0,0 c 0,0.4294054 -1.2219064,0.7775068 -2.7291777,0.7775068 -1.5072734,0 -2.7291614,-0.3481014 -2.7291614,-0.7775068 l 0,0 c 0,-0.4294054 1.221888,-0.7775054 2.7291614,-0.7775054 1.5072733,0 2.7291777,0.3481 2.7291777,0.7775054 l 0,2.1033228 c 0,0.429405 -1.2219064,0.777506 -2.7291777,0.777506 -1.5072734,0 -2.7291614,-0.348101 -2.7291614,-0.777506 l 0,-2.1033228",
    style: {
      fill: "#000000",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.26458332,
      strokeLinecap: "square",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.967067,9.2260482 0,0 c 0,0.4294054 -1.2219064,0.7775068 -2.7291777,0.7775068 -1.5072734,0 -2.7291614,-0.3481014 -2.7291614,-0.7775068 l 0,0 c 0,-0.4294054 1.221888,-0.7775054 2.7291614,-0.7775054 1.5072733,0 2.7291777,0.3481 2.7291777,0.7775054 l 0,2.1033228 c 0,0.429405 -1.2219064,0.777506 -2.7291777,0.777506 -1.5072734,0 -2.7291614,-0.348101 -2.7291614,-0.777506 l 0,-2.1033228",
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#326ce5",
      strokeWidth: 0.5291667,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatefulset);
export default __webpack_public_path__ + "static/media/statefulset.6b1033ed21ffbb70d862904dec26ab08.svg";
export { ForwardRef as ReactComponent };